export function proxyDisplayStatus(proxy) {
    const states = {
        online: { key: 'online', label: 'Online', color: 'green' },
        rotating: { key: 'rotating', label: 'Rotating', color: 'amber-darken-2' },
        checking: { key: 'checking', label: 'Checking', color: 'amber-darken-2' },
        offline: { key: 'offline', label: 'Offline', color: 'red' },
        // ProxySmart only: the port is up but has as many live connections as its limit allows
        maxconn: { key: 'maxconn', label: 'Max connections exceeded', color: 'amber-darken-2' },
    };
    const live = proxy.m_type === 'PROXYSMART' || proxy.m_type === 'X_PROXY' || proxy.m_type === 'PROPROXYUI';
    if (live && proxy.display_status === 'online' && proxy.conn_limited === true) return states.maxconn;
    if (live && states[proxy.display_status]) return states[proxy.display_status];
    const online = ['CONNECTED', 'true', true].includes(proxy.proxy_status) && proxy.modem_conn_status;
    return states[online ? 'online' : 'offline'];
}
